import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';

gsap.registerPlugin( ScrollTrigger, CustomEase, DrawSVGPlugin );

( function( app ) {
  const COMPONENT = {
    init: function() {},

    finalize: function() {
      this.animate();
    },

    animate: function() {
      // Clear existing ScrollTrigger instances to prevent stacking issues
      ScrollTrigger.getAll().forEach( ( trigger ) => trigger.kill() );

      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if (
          ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) ||
          ( typeof elements === 'object' && elements.length > 0 )
        ) {
          gsap.set( elements, startAnimationObj );

          const triggers = ScrollTrigger.batch( elements, {
            toggleClass: 'js-animated',
            once: true,
            start: start,
            onEnter: ( triggerElements ) => {
              animationFunction( triggerElements, 'original' );
            },
          } );

          ScrollTrigger.addEventListener( 'refreshInit', () => {
            triggers.forEach( ( trigger ) => {
              if ( trigger.progress > 0 ) {
                animationFunction( [trigger.trigger], 'refresh' );
              }
            } );
          } );
        }
      }

      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        elements.forEach( ( element ) => {
          const tl = gsap.timeline();

          tl.to( element, {
            autoAlpha: 1,
            duration: 0.35,
            ease: 'power1.out',
            stagger: 0.1,
          }, 0 );

          tl.to( element, {
            y: 0,
            duration: 1,
            ease: 'power2.out',
            stagger: 0.1,
          }, 0 );
        } );
      }
      createAnimation( fadeUpClasses, {autoAlpha: 0, y: 25}, fadeUpTimeline );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements, {
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: 1.5,
          ease: 'power2.out',
          stagger: 0.2,
        } );
      }

      createAnimation( '.js-reveal-right:not(.js-ignore)', {clipPath: 'inset(0 100% 0 0)'}, reveal );
      createAnimation( '.js-reveal-left:not(.js-ignore)', {clipPath: 'inset(0 0 0 100%)'}, reveal );

      /*
       * Draw SVG
       */
      function draw( elements ) {
        elements.forEach( ( element ) => {
          const tl = gsap.timeline();
          tl.to( element, {duration: 2, drawSVG: '100%'} );
          tl.to( element, {autoAlpha: 1, duration: 0.35}, 0 );
        } );
      }
      createAnimation( '.js-draw:not(.js-ignore)', {drawSVG: '0%'}, draw );

      function drawReverse( elements ) {
        elements.forEach( ( element ) => {
          const tl = gsap.timeline();
          tl.to( element, {duration: 2, drawSVG: '0% 100%'} );
          tl.to( element, {autoAlpha: 1, duration: 0.35}, 0 );
        } );
      }
      createAnimation( '.js-draw-reverse:not(.js-ignore)', {drawSVG: '100% 100%', autoAlpha: 0}, drawReverse );

      /*
       * Float
       */
      window.addEventListener( 'load', () => {
        function float( elements ) {
          const tl = gsap.timeline( {
            defaults: {duration: 0.5, ease: 'power1.out'},
          } );

          tl.to( elements, {opacity: 1, y: -15, duration: 1, ease: 'power2.out'} );
          tl.to( elements, {y: 0, duration: 1, ease: 'power2.out'}, '-=0.5' );
        }

        createAnimation( '.js-float:not(.js-ignore)', {opacity: 0, y: 60}, float );
      } );

      // Refresh ScrollTrigger after a short delay to fix animations failing after multiple reloads
      setTimeout( () => {
        ScrollTrigger.refresh();
      }, 200 );
    },

    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => el.classList.remove( 'js-fade' ) );
    },
  };

  app.registerComponent( 'animations', COMPONENT );
} )( app );
